import {secondaryColor} from '../../styles/style';

const style = {
  clientBundlesTable__text_link: {
    'color': `${secondaryColor}!important`,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export default style;
